<template>
  <div style="height: calc(100vh - 170px); overflow: auto">
    <div style="min-height: 600px">
      <el-form
        class="ghost-button-styles"
        ref="uploadFormRef"
        :rules="uploadFormRules()"
        :model="landData"
        label-width="310px"
        @submit.native.prevent
      >
        <el-form-item label="素材类型">
          <el-radio-group v-model="landData.imageType" @change="reset">
            <el-radio-button v-for="i in IMAGE_TYPES_LIST" :key="i.type" ghost :label="i.type" :disabled="disabledUpload">
              {{ i.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="上传类型"
          v-if="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.VIDEO, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.LOGO].includes(landData.imageType)"
        >
          <el-radio-group v-model="landData.uploadType" @change="changeUploadType">
            <el-radio-button ghost :label="UPLOAD_TYPE.NEW">新素材</el-radio-button>
            <el-radio-button ghost :label="UPLOAD_TYPE.LEGACY" :disabled="!lagecyMaterialEnabled">绑定老素材</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择老素材"
          prop="bindMaterId"
          :key="landData.imageType + landData.uploadType + 'bindMaterId'"
          v-show="materialType.legacy"
        >
          <el-input
            :value="landData.bindMaterName"
            suffix-icon="el-icon-search"
            style="width: 280px"
            @focus="pickMaterialShow"
            @click="pickMaterialShow"
          />
        </el-form-item>
        <!-- 图片类型：单图 -->
        <el-form-item v-show="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.LOGO].includes(landData.imageType)" label="图片类型">
          <el-radio-group v-model="landData.imageCount">
            <el-radio-button ghost :label="IMAGE_COUNT.SINGLE">单图</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 上传图片 -->
        <el-form-item
          prop="uploadList"
          :key="landData.imageType + 'uploadList'"
          v-if="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.LOGO, IMAGE_TYPES.STICKERS, IMAGE_TYPES.PLAYABLE].includes(landData.imageType)"
          label="上传图片"
        >
          <FileUploader
            v-model="uploadList"
            @change="onUploadListChange"
            :multiple="landData.imageType === IMAGE_TYPES.PLAYABLE ? false : true"
            :before-upload="landData.imageType === IMAGE_TYPES.PLAYABLE ? playableImageUploadInterceptor : imageUploadInterceptor"
          >
            <template #placeholder="{ file }">
              <img :src="file.response.data.url" width="107px" height="107px" />
            </template>
          </FileUploader>
        </el-form-item>

        <!-- 图片类型：组图 -->
        <el-form-item v-if="[IMAGE_TYPES.GROUP_IMAGE].includes(landData.imageType)" label="图片类型">
          <el-radio-group v-model="landData.imageCount">
            <el-radio-button ghost :label="IMAGE_COUNT.GROUP">组图</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 组图 -->
        <template v-if="[IMAGE_TYPES.GROUP_IMAGE].includes(landData.imageType)">
          <el-form-item label="上传组图">
            <el-dropdown @command="groupImageUploaderTrigger">
              <el-button> 上传组图<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in GROUP_IMAGE_TYPE_LIST" :command="item.value" :key="item.value">
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>

          <!-- 上传组图 -->
          <el-form-item v-show="false">
            <!-- groupImageUploaderTrigger 触发上传 -->
            <el-upload
              ref="groupImageUploaderRef"
              :action="uploadUrl"
              :show-file-list="false"
              :file-list="groupImageUploadList"
              :auto-upload="false"
              :on-change="onGroupImageUpload"
              :on-success="onGroupImageUploadSuccess"
              drag
              multiple
              with-credentials
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item v-loading="groupImageUploadLoading" :key="landData.imageType + 'groupImageList'" prop="groupImageList">
            <ImageGroupMaterial
              v-for="(images, index) in groupImageList"
              :key="images.map((i) => i.id).join('')"
              :images.sync="groupImageList[index]"
              :index="index"
              draggable
              :show-desc="false"
              @remove="onSelectedGroupImageRemove(index)"
            >
              <template #material-name>
                <el-input
                  style="width: 100%"
                  @input="uploadFormRef.clearValidate()"
                  v-model="groupImageNames[index]"
                  placeholder="请输入素材名称"
                ></el-input>
              </template>
            </ImageGroupMaterial>
          </el-form-item>
        </template>

        <!-- 上传音频 -->
        <el-form-item v-if="landData.imageType === IMAGE_TYPES.AUDIO" label="上传音频" class="required">
          <FileUploader v-model="uploadList" @change="onUploadListChange" :before-upload="audioUploadInterceptor">
            <template #placeholder>
              <img src="~assets/images/audio.png" width="107px" height="107px" />
            </template>
          </FileUploader>
        </el-form-item>

        <!-- 上传视频 -->
        <el-form-item
          v-if="[IMAGE_TYPES.VIDEO, IMAGE_TYPES.META].includes(landData.imageType)"
          label="上传视频"
          class="required"
          prop="uploadList"
          :key="landData.imageType + 'uploadList'"
        >
          <FileUploader v-model="uploadList" @change="onUploadListChange" :before-upload="videoUploadInterceptor">
            <template #placeholder="{ file }">
              <video :src="file.response.data.url" width="107px" height="107px">您的浏览器不支持 video 标签。</video>
            </template>
          </FileUploader>

          <p style="font-size: 12px">可以一次性批量选择30个视频上传</p>
        </el-form-item>

        <el-form-item
          v-if="landData.imageType === IMAGE_TYPES.PLAYABLE"
          :key="landData.imageType + 'playableMaterialName'"
          prop="playableMaterialName"
          label="素材名称"
        >
          <el-input v-model="landData.playableMaterialName" style="width: 420px" />
        </el-form-item>

        <GameGroupFormItems
          v-if="
            [
              IMAGE_TYPES.IMAGE,
              IMAGE_TYPES.VIDEO,
              IMAGE_TYPES.GROUP_IMAGE,
              IMAGE_TYPES.META,
              IMAGE_TYPES.LOGO,
              IMAGE_TYPES.PLAYABLE
            ].includes(landData.imageType)
          "
          :form-data="landData"
          @group-change="handleGroup"
          @game-change="hanldeGame"
        ></GameGroupFormItems>

        <el-form-item
          v-if="landData.imageType === IMAGE_TYPES.PLAYABLE"
          :key="landData.imageType + 'gdtPlayableId'"
          prop="gdtPlayableId"
          label="媒体试玩ID"
        >
          <el-input v-model="landData.gdtPlayableId" style="width: 420px" placeholder="填写媒体的试玩ID" />
          <p style="font-size: 12px">
            说明：腾讯试玩ID，请到媒体后台获取，ID类似“playable@wx5d08f8487e0c15c4@CBgAA84CRhvnJt09pRX5gg6ayhJ4”
          </p>
        </el-form-item>

        <!-- 新素材上传且图片、组图、视频素材类型显示 -->
        <CommonFormItems
          v-if="
            materialType.new &&
            [IMAGE_TYPES.IMAGE, IMAGE_TYPES.VIDEO, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.META, IMAGE_TYPES.PLAYABLE].includes(
              landData.imageType
            )
          "
          v-model="landData"
        >
          <template #exclude-media v-if="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.VIDEO, IMAGE_TYPES.GROUP_IMAGE].includes(landData.imageType)">
            <el-form-item label="限制使用媒体">
              <el-switch v-model="landData.excludeMediaSwitch" />
              <div>
                <el-select v-if="landData.excludeMediaSwitch" v-model="landData.excludeMediaIds" multiple filterable style="width: 420px">
                  <el-option v-for="media of mediaData" :key="media.mediaId" :value="media.mediaId" :label="media.mediaName"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </template>
        </CommonFormItems>

        <template v-if="landData.imageType === IMAGE_TYPES.VIDEO">
          <el-form-item label="AI分析">
            <el-switch v-model="landData.aiLabelEnable" />
            <p style="font-size: 12px">启用后，AI将自动分析视频内容，识别并生成内容标签，同时提供优化建议。</p>
          </el-form-item>

          <el-form-item label="AI素材审核">
            <el-switch v-model="landData.aiAuditEnabled" />
            <p style="font-size: 12px">
              <span> 启用后，素材需经AI按审核配置自定审核，通过后方可投放。 </span>
              <el-button @click="openAIMaterialAnalysisConfigPage" type="text">查看配置</el-button>
            </p>
          </el-form-item>
        </template>

        <template v-if="landData.imageType === IMAGE_TYPES.META">
          <el-form-item label="AI字幕" class="required">
            <el-switch v-model="landData.subtitleEnable" />
            <p style="font-size: 12px">注意：对于无需生成字幕的视频片段，请关闭开关。</p>
          </el-form-item>

          <el-form-item label="AI分析">
            <el-switch v-model="landData.aiLabelEnable" />
            <p style="font-size: 12px">通过AI分析视频内容，自动生成内容标签。</p>
          </el-form-item>

          <el-form-item v-if="landData.aiLabelEnable" label="AI视频解析策略">
            <el-select
              v-model="landData.aiStrategyIds"
              style="width: 420px"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="请先选择游戏，为空默认不选择策略"
            >
              <el-option v-for="item in aiStrategyList" :key="item.id" :value="item.id" :label="item.promptName"> </el-option>
            </el-select>
            <p style="font-size: 12px">
              根据视频的类型及其关注重点，针对性地选择合适的解析策略，有助于更高效地提取标签并深入理解视频内容。
            </p>
          </el-form-item>

          <el-form-item label="AI素材审核">
            <el-switch v-model="landData.aiAuditEnabled" />
            <p style="font-size: 12px">
              <span> 启用后，素材需经AI按审核配置自定审核，通过后方可投放。 </span>
              <el-button @click="openAIMaterialAnalysisConfigPage" type="text">查看配置</el-button>
            </p>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="default" @click="reset" :disabled="disabledUpload">重置</el-button>
          <el-button type="primary" style="margin-left: 8px" :loading="submitLoading" @click="submit" :disabled="disabledUpload">
            确定上传
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 选择对比素材列表 -->
    <pick-material v-model="pickModel" :type="landData.imageType" @on-select="pickMaterialSelect" />

    <!-- 上传结果展示框 -->
    <el-dialog title="素材上传结果" :visible.sync="uploadResModal" :show-close="false" :close-on-click-modal="false" width="760px">
      <el-table class="common-el-table-styles" border max-height="320" :data="uploadResult">
        <el-table-column prop="name" label="素材名称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="msg" label="上传结果" show-overflow-tooltip></el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="closeResultModal">知道了</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, nextTick } from 'vue'
import store from '@/store'
import { Message } from 'view-design'
import Cookies from 'js-cookie'
import PickMaterial from '@/components/material/material.vue'
import FileUploader from './components/file-uploader.vue'
import CommonFormItems from './components/upload-form-items.vue'
import GameGroupFormItems from './components/game-group-form-items.vue'
import VideoProcess from './components/upload-video-process.vue'
import ImageGroupMaterial from '@/views/create/gdt/v3/components/creative/image-group.vue'

import { useBeforeUpload, useFormRules, useComputeds, useGroupImageUpload } from './hooks/useUpload.js'
import { uploadMetarial, getAiStrategyList } from '@/api/material.model.js'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { IMAGE_TYPES_LIST, UPLOAD_TYPE, IMAGE_TYPES, IMAGE_COUNT, GROUP_IMAGE_TYPE_LIST, getUploadFormDefaultFields } from './consts.js'
import { LABEL_TYPES, LEVEL_TYPES, UPLOAD_SOURCE_TYPES } from '../tags/const.js'
import { initPageData, GAME_GROUPS, SYS_TAGS, MEDIAS, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, SYS_TAGS, MEDIAS, IMAGE_STYLE_TAG_TREE])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS, SYS_TAGS)
const mediaData = computed(PAGE_REQUIRED_OPTS.MEDIAS)
const aiStrategyList = ref([])
const account = Number(Cookies.get('ch_op_id'))
const uploadUrl = `${HOST_API}/api/ptom/imageInfo/upload`

const authList = computed(() => store.state.accessAuth)
const changeTypeLoading = ref(false)
const uploadFormRef = ref(null) // 表单ref

// 响应式状态
const submitLoading = ref(false)
const pickModel = ref(false)
const uploadList = ref([]) // 上传列表
const uploadResult = ref([]) // 上传素材结果数据
const uploadResModal = ref(false) // 上传素材结果展示框

// 响应式对象
const landData = reactive({
  ...getUploadFormDefaultFields(),
  opId: account
})

const {
  groupImageUploaderRef,
  groupImageList,
  groupImageNames,
  groupImageUploadList,
  onSelectedGroupImageRemove,
  groupImageUploaderTrigger,
  onGroupImageUploadSuccess,
  onGroupImageUpload,
  groupImageUploadLoading,
  uploadedGroupImageListValidator
} = useGroupImageUpload(landData)
const { audioUploadInterceptor, imageUploadInterceptor, playableImageUploadInterceptor, videoUploadInterceptor } =
  useBeforeUpload(uploadList)
const { uploadFormRules } = useFormRules(landData, uploadList, uploadedGroupImageListValidator)
const { lagecyMaterialEnabled, materialType } = useComputeds(landData)

const disabledUpload = computed(() => uploadList.value.some((ret) => ret.status !== 'success'))

const changeType = async (type) => {
  reset()

  // changeTypeLoading.value = true
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 110)
  // })

  // changeTypeLoading.value = false
}

const changeUploadType = () => {
  landData.bindMaterId = 0
  landData.bindMaterName = ''
}

const pickMaterialShow = () => {
  pickModel.value = true
}

const pickMaterialSelect = (val) => {
  if (val && val.imageId && val.imageName) {
    landData.bindMaterId = val.imageId
    landData.bindMaterName = val.imageName
  } else {
    Message.warning('选择的对比素材信息有误！')
  }
}

const openAIMaterialAnalysisConfigPage = () => {
  window.open(`${window.location.origin}/tools/aimaterialanalysisconfig`, '_blank')
}

/**
 * @description: 根据游戏id获取ai解析策略
 * @param {*} gameIds
 * @return {*}
 */
function queryAiStrategyList(gameIds = '') {
  getAiStrategyList({ gameIds: Array.isArray(gameIds) && gameIds.length ? gameIds.join(',') : '' }).then((data) => {
    aiStrategyList.value = data
  })
}

// 默认获取全局辅助提示词
queryAiStrategyList()

/**
 * @description: 选择游戏组后过滤对应组下面的游戏，追加到游戏中
 * @param {*} val
 * @return {*}
 */
function handleGroup(val) {
  const games = []
  const oldGames = JSON.parse(JSON.stringify(landData.game))
  if (isArray(val) && val.length) {
    val.forEach((ret) => {
      const index = gameGroups.value.findIndex((met) => met.id === ret)
      if (index > -1) {
        const { gameIds } = gameGroups.value[index]
        const child = gameIds.filter((met) => !oldGames.includes(parseInt(met))).map((met) => parseInt(met))
        games.push(...child)
      }
    })
    if (games.length) {
      landData.game.push(...games)
      hanldeGame(games)
    }
    uploadFormClearValidate(['game'])
  }
  // 切换游戏组时清空已选内容标签结果
  landData.label = []
}

/**
 * @description: 切换游戏、游戏组后，清空当前的ai解析策略并获取新的ai解析策略
 * @param {*} games
 * @return {*}
 */
function hanldeGame(games) {
  aiStrategyList.value = []
  landData.aiStrategyIds = ''
  queryAiStrategyList(games)
}

function onUploadListChange() {
  uploadFormClearValidate()
  if (landData.imageType === IMAGE_TYPES.PLAYABLE) {
    nextTick(() => {
      const [file] = uploadList.value
      const [namePrefix] = file?.name?.split('.')
      if (namePrefix) {
        landData.playableMaterialName = namePrefix
      }
    })
  }
}

function uploadFormClearValidate(props = []) {
  uploadFormRef.value?.clearValidate(props)
}

const reset = () => {
  const { imageType, opId, plannerId } = landData
  uploadList.value.splice(0, uploadList.value.length)

  // 切换组图或其他时的图片类型
  const imageCount = imageType === IMAGE_TYPES.GROUP_IMAGE ? IMAGE_COUNT.GROUP : IMAGE_COUNT.SINGLE
  Object.assign(landData, {
    ...getUploadFormDefaultFields(),
    imageType,
    opId,
    plannerId,
    imageCount
  })
}

function getOperatorStorage(name) {
  const storage = getLocal(name) || {}
  return storage[account] || {}
}

function setOperatorStorage(name, value) {
  const storage = getLocal(name) || {}
  storage[account] = value
  setLocal(name, storage)
}

const submit = async () => {
  try {
    const valid = await uploadFormRef.value.validate()
    if (!valid) return
    // 一级素材样式：imageStyle  二级素材样式：imageStyle2  3D视频源标签：videoLabelIds
    const { label, videoLabelIds, imageStyles, typeLabelIds, subtitleEnable, aiLabelEnable, aiAuditEnabled, aiStrategyIds } = landData
    const gameIds = landData.game.join(',')
    const fileInfos = uploadList.value.map((ret) => ret.response.data)

    const imageStyle = []
    const imageStyle2 = []

    imageStyles.forEach((s) => {
      const [parentId, childId] = s
      imageStyle.push(parentId)
      if (childId) imageStyle2.push(childId)
    })

    // 内容标签和3d视频源合并参数
    // 20250514新增素材样式合并参数
    // 20250516新增营销主题标签合并参数
    const labelIds = [label, videoLabelIds, imageStyle, imageStyle2, typeLabelIds]
      .filter((i) => Array.isArray(i))
      .flat()
      .join(',')
    let plannerId = landData.plannerId
    let excludeMediaIds = landData.excludeMediaIds
    if (isArray(plannerId)) plannerId = plannerId.join(',')
    if (isArray(excludeMediaIds)) excludeMediaIds = excludeMediaIds.join(',')

    const params = {
      imageType: landData.imageType,
      gameIds: gameIds,
      labelIds: labelIds,
      source: landData.source,
      designerId: landData.opId,
      plannerId: plannerId,
      excludeMediaIds: landData.excludeMediaSwitch ? excludeMediaIds : undefined,
      fileInfos
    }

    if (landData.imageType === IMAGE_TYPES.META) {
      params.subtitleEnable = subtitleEnable
      params.aiLabelEnable = aiLabelEnable
      params.aiAuditEnabled = aiAuditEnabled

      if (aiLabelEnable && aiStrategyIds?.length) {
        params.aiStrategyIds = aiStrategyIds.join(',')
      } else {
        params.aiStrategyIds = ''
      }
    }
    if (landData.imageType === IMAGE_TYPES.VIDEO) {
      params.aiLabelEnable = aiLabelEnable
      params.aiAuditEnabled = aiAuditEnabled
    }

    if (landData.imageType === IMAGE_TYPES.GROUP_IMAGE) {
      params.fileInfos = groupImageList.value.map((group, index) => {
        const [firstImg] = group
        const { width, height, suffix } = firstImg
        const maxSize = Math.max(...group.map((img) => img.size))
        const groupImageName = groupImageNames.value[index]
        return {
          width,
          height,
          name: `${groupImageName}.${suffix}`,
          size: maxSize,
          groupImageMd5s: group.map((img) => img.signature).join(','),
          groupImageUrls: group.map((img) => img.preview_url).join(',')
        }
      })
    }

    if (landData.imageType === IMAGE_TYPES.PLAYABLE) {
      const [firstFile] = params.fileInfos
      const { name } = firstFile
      const suffix = (name?.split('.') || []).slice(-1)
      params.fileInfos = [
        {
          ...firstFile,
          name: `${landData.playableMaterialName}.${suffix}`
        }
      ]

      params.gdtPlayableId = landData.gdtPlayableId
    }

    // 绑定老素材
    if (materialType.value.legacy) params.bindMaterId = landData.bindMaterId
    if (landData.lauchTime) params.lauchTime = landData.lauchTime

    submitLoading.value = true
    try {
      const data = await uploadMetarial(params)
      submitLoading.value = false
      if (data) {
        uploadResModal.value = true
        uploadResult.value = data
      }
    } catch (error) {
      submitLoading.value = false
      console.error(error)
    }
  } catch (e) {
    console.log('upload error output: ', e)
  }
}

const closeResultModal = () => {
  // 关闭素材上传结果弹窗
  uploadResModal.value = false
  uploadList.value.splice(0, uploadList.value.length)

  const failedItems = uploadResult.value.filter((ret) => ret.status === '0')
  if (failedItems.length) {
    const failedIndexs = failedItems.map((ret) => Number(ret.index))
    groupImageList.value = groupImageList.value.filter((_, index) => failedIndexs.includes(index))
    groupImageNames.value = groupImageNames.value.filter((_, index) => failedIndexs.includes(index))
  } else {
    groupImageList.value = []
    groupImageNames.value = []
  }
}
</script>

<style lang="scss" scoped>
.upload-form {
  padding-top: 20px;
}

::v-deep .material-styles-checkbox {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  .el-checkbox {
    margin: 0 !important;

    .el-checkbox__label {
      display: inline-block;
      text-overflow: ellipsis;
      max-width: 120px;
      overflow: hidden;
      white-space: nowrap;
      vertical-align: middle;
    }
  }
}
</style>
